import { render, staticRenderFns } from "./CollapsibleComponent.vue?vue&type=template&id=843d56c2&"
import script from "./CollapsibleComponent.vue?vue&type=script&lang=js&"
export * from "./CollapsibleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports